import type { LicenseData } from "../hooks/useLicenseStore"

const isYes = (value: unknown) =>
  value === true || (typeof value === "string" && value.trim().toLowerCase() === "yes")

export const applyPublishingRules = (data: LicenseData): LicenseData => {
  const requirements = data.publishingRequirements as Record<string, boolean> | undefined
  const reporting = isYes(data.publishingPermitted) && !!requirements?.reporting

  if (!reporting) {
    return { ...data, reportingRequirements: "No", reportingTypesPermitted: "" }
  }
  if (!isYes(data.reportingRequirements)) {
    return { ...data, reportingTypesPermitted: "" }
  }
  return data
}
